export const platformHappeningBlocks = [
  {
    id: 'anthology',
    number: '01',
    numberBackground: '#A9F84A',
    numberColor: '#121212',
    numberRotation: 3,
    title: 'Первый межавторский сборник',
    descriptionMobile:
      'В Molwe уже запущен формат сборников — точка входа для авторов, которые хотят быть частью общего проекта',
    descriptionDesktop: [
      'В Molwe уже запущен формат сборников — точка входа для',
      'авторов, которые хотят быть частью общего проекта',
    ] as const,
    chips: [
      'Фэнтези',
      'Мистика',
      'Городские легенды',
      'Альтернативные миры',
      'Романтика',
      'Будущее',
    ] as const,
    illustration: {
      src: '/images/original-plus/platform-happening/illustration-01.svg',
      width: 140,
      height: 140,
    },
    spanTwoColumns: true,
  },
  {
    id: 'authors',
    number: '02',
    numberBackground: '#B45CFF',
    numberColor: '#FFFFFF',
    numberRotation: 2,
    title: 'Реальные авторы и произведения',
    description:
      'На платформе уже есть авторы и оригинальные тексты, которые можно развивать, упаковывать и продвигать',
    illustration: {
      src: '/images/original-plus/platform-happening/illustration-02.svg',
      width: 125,
      height: 90,
    },
    spanTwoColumns: false,
  },
  {
    id: 'themes',
    number: '03',
    numberBackground: '#4D7EFF',
    numberColor: '#FFFFFF',
    numberRotation: -2,
    title: 'Новые тематические сборники',
    description:
      'Формируются следующие темы и окна входа для авторов – тематика подбирается под жанры платформы',
    illustration: {
      src: '/images/original-plus/platform-happening/illustration-03.svg',
      width: 125,
      height: 90,
    },
    spanTwoColumns: false,
  },
  {
    id: 'media',
    number: '04',
    numberBackground: '#FF66C4',
    numberColor: '#121212',
    numberRotation: 3,
    title: 'Медиа и фестивали',
    description:
      'Лучшие авторы могут попадать в медиаформаты, офлайн – мероприятия, фестивали и партнёрские проекты',
    illustration: {
      src: '/images/original-plus/platform-happening/illustration-04.svg',
      width: 125,
      height: 90,
    },
    spanTwoColumns: false,
  },
  {
    id: 'community',
    number: '05',
    numberBackground: '#A9F84A',
    numberColor: '#121212',
    numberRotation: -4,
    title: 'Комьюнити',
    description:
      'Molwe развивает среду для авторов и читателей: публикации, подборки, обсуждения, проекты',
    illustration: {
      src: '/images/original-plus/platform-happening/illustration-05.svg',
      width: 125,
      height: 90,
    },
    spanTwoColumns: false,
  },
] as const;

export type PlatformHappeningBlock = (typeof platformHappeningBlocks)[number];
